<template lang="pug">
  .article
    Hero(:titulo="article.title", :bajada="article.undertitle", :imagen="article.featuredimage" :single="true" :videohtml="article.videohtml" :tipo="article.type" :beneathtitle="article.beneathtitle")
    .text
      .credits(v-html="article.credits")
      .content(v-html="article.content")

</template>
<script>
import Hero from '@/components/Hero'

export default {
  components: {
    Hero
  },
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    article(){
      const ble = this.$store.getters.getArticle(this.slug)
      if(typeof ble === 'undefined'){
        this.$router.push({name: 'home'})
      }
      return ble
    }
  }
}
</script>
<style lang="scss">
  .article{

  }
  .text{
    position: relative;
    z-index: 2;
    background-color: white;
    padding: 1px 0;
  }

  .credits{
    max-width: 720px;
    text-align: center;
    margin: 6rem auto;
    padding: 0 1rem;
    p{
      font-family: 'Open Sans', sans-serif;
      margin: 0;
    }
  }

  .content{
    padding: 0 1rem;
    > p:first-child:first-letter {
      // color: #e4a612;
      float: left;
      text-transform: uppercase;
      font-weight: 900;
      font-family: 'Georgia';
      font-size: 6.6rem;
      text-transform: uppercase;
      line-height: 5.4rem;
      padding-top: 4px;
      padding-right: 8px;
      margin-left: -6px;
    }
    p {
      font-family: 'Georgia', serif;
      max-width: 720px;
      margin-left: auto;
      margin-right: auto;
      font-size: 1.25rem;
      line-height: 1.7em;
      margin-bottom: 1.7rem;
      @include fluid-type(360px, 1440px, 16px, 20px);
      color: #2a2a2a;
      text-shadow: 0 1px 0 #fff;
    }
    .special-box{

      max-width: 1040px;
      margin-left: auto;
      margin-right: auto;
      padding-top: 1px;
      figure{
        float: left;
        max-width: 360px;
        padding: 0 1rem 0;
        @media (max-width: 800px){
          float: none;
        }
      }
      h3{
        font-size: 2.3rem;
        margin: 2rem 0;
        small{
          font-size: 1.5rem;
          margin-bottom: 1rem;
          display: block;
        }
      }
    }
    .vwrap{
      max-width: 1040px;
      margin: 2rem auto;
    }
    figure{
      display: flex;
      flex-direction: column;
      max-width: 1040px;
      margin-left: auto;
      margin-right: auto;
      img{
        max-width: 100%;
        height: auto;

      }
      figcaption{
        display: none;
        p{
          font-family: 'Open Sans', sans-serif;
          font-size: 12px;
          text-align: center;
          text-transform: uppercase;
        }
      }
    }
  }

</style>


